import React, { useEffect, useState } from 'react'
import { Chart as ChartJS, ArcElement, Legend, Colors } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Legend);

const optionsWorkflow = {
    responsive: true,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                color: '#9e9e9e',
                align: 'start', // Left-align the labels
                usePointStyle: true,
                padding: 10,
            },
        },
    },
    cutout: '60%',
}

function WorkflowChartWidget({ workFlowChart }) {

    const totalTasks = (workFlowChart?.todo || 0) +
        (workFlowChart?.inprogress || 0) +
        (workFlowChart?.complete || 0) +
        (workFlowChart?.delay || 0) +
        (workFlowChart?.completeDelay || 0);

    const hasData = totalTasks > 0;

    const data = {
        labels: ['Todo', 'In Progress', 'Completed', 'Delay', 'Delay Completed'],
        datasets: [
            {
                data: [workFlowChart && workFlowChart.todo, workFlowChart && workFlowChart.inprogress, workFlowChart && workFlowChart.complete, workFlowChart && workFlowChart.delay, workFlowChart && workFlowChart.completeDelay],
                backgroundColor: [
                    // 'rgb(233, 235, 238)',
                    'rgb(146, 146, 146)',
                    'rgb(115, 97, 231)',
                    'rgb(100, 207, 92)',
                    'rgb(236, 219, 90)',
                    'rgb(232, 77, 77)',
                ],
                borderWidth: 0,
            },
        ],
    };
    //dark theme image change
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        // Check for the theme on initial load
        const currentTheme = document.body.classList.contains("dark-theme");
        setIsDarkTheme(currentTheme);

        // Listen for changes to the body's class (if toggling happens outside this component)
        const observer = new MutationObserver(() => {
            const updatedTheme = document.body.classList.contains("dark-theme");
            setIsDarkTheme(updatedTheme);
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

        // Cleanup observer on component unmount
        return () => observer.disconnect();
    }, []);
    //dark theme image change end
    return (
        <>
            <div className='card text-center graph-card h-100 mb-0'>
                <div className='card-body'>
                    <h5 className='card-title mb-2'>Workflow<br/><small>(Dependent Task)</small></h5>
                    {hasData ?
                        <div className='chart-wrap'>
                            <Doughnut options={optionsWorkflow} data={data} />
                            <p>Select / Deselect legends</p>
                        </div> :
                        <div className='chart-wrap-nodata'>                            
                            <img
                                src={
                                    isDarkTheme
                                        ? `${process.env.PUBLIC_URL}/assets/images/graph-nodata-dark.png`
                                        : `${process.env.PUBLIC_URL}/assets/images/graph-nodata.png`
                                }
                                className="img-fluid"
                                alt="no-data"
                            />
                        </div>

                        // <div style={{ height: "100%", display: 'flex', justifyContent: "center", alignItems: "center", fontSize: "20px" }}> <p>No Data Found</p></div>

                    }
                </div>
            </div>
        </>
    )
}

export default WorkflowChartWidget